import { en } from './en';
import { zh } from './zh';
import { ja } from './ja';
import { es } from './es';
import { fr } from './fr';

export const translations = {
  en,
  zh,
  ja,
  es,
  fr
};
